import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Company } from "src/app/models/company.model";
import { Group } from "src/app/models/group.model";
import { Plant } from "src/app/models/plant.model";
import { TempGroup } from "src/app/models/tempgroup.model";
import { TempUser } from "src/app/models/tempuser.model";
import { User } from "src/app/models/user.model";
import { AuthService } from "src/app/services/auth/auth.service";
import { CompanyService } from "src/app/services/company/company.service";
import { ErrorHandlerService } from "src/app/services/errorHandler/error-handler.service";
import { GroupService } from "src/app/services/group/group.service";
import { PlantService } from "src/app/services/plant/plant.service";
import { ToastService } from "src/app/services/toast/toast.service";
import { Roles } from "src/app/auth/roles";

@Component({
  standalone: false,
  selector: "app-edit-non-admin-user",
  templateUrl: "./edit-non-admin-user.component.html",
  styleUrls: ["./edit-non-admin-user.component.css"],
})
export class EditNonAdminUserComponent {
	readonly Roles = Roles;
  constructor(
    private route: ActivatedRoute,
    private groupService: GroupService,
    private plantService: PlantService,
    private companyService: CompanyService,
    private router: Router,
    public toastService: ToastService,
    private authService: AuthService,
    private errorService: ErrorHandlerService,
  ) { }

  subtext: string = "Select a Group to edit.";
  companies: Company[] = [];
  plants: Plant[] = [];
  groups: Group[] | TempGroup[] = [];
  editMode: string = "";
  userTypes = [
    {
      id: 1,
      type: "System Users"
    },
    {
      id: 2,
      type: "Temporary Users"
    }
  ]

  selectedCompany = {
    companyId: 0,
    companyName: "",
    isDeleted: false,
  };

  selectedPlant = {
    plantId: 0,
    plantName: "",
    isDeleted: false,
  };

  selectedRole = "Non-Admin User";
  firstName = "";
  lastName = "";
  email = "";
  resetPlant = false;
  resetCompany = false;
  currentRole: any = "";
  selectedNonAdminUser: User = {
    userId: 0,
    firstName: "",
    lastName: "",
    email: "",
    role: "",
    group: "",
    isDeleted: false,
  };

  selectedTempUser: TempUser = {
    tempUserId: 0,
    firstName: "",
    lastName: "",
    email: "",
    tempUserGroupId: 0,
    isDeleted: false
  }

  errorMessage = {
    success: true,
    message: "",
  };

  dropdownStyles = {
    // width: '260px',
    // height: '43px',
    // marginRight: '25px',
    // borderColor: 'var(--default-gray-400, #b3bdc6)'
  };

  dropdownWrapperStyle = {
    // width: '260px',
    // top:'42px',
    // borderColor: 'var(--default-gray-400, #b3bdc6)'
  };
  currentGroup: any = "";

  editNonAdminUser() {
    const payload: any = {
      groupName: (this.editMode == 'non-admin' ? this.selectedNonAdminGroup.groupName : this.selectedTempGroup.groupName),
      PrevGroup: this.currentGroup?.groupName,
      plantId: this.selectedPlant?.plantId || (this.editMode == 'non-admin' ? this.selectedNonAdminGroup.plantId : this.selectedTempGroup.plantId),
    };

    if (this.editMode == 'non-admin') {
      const subjectId = this.selectedNonAdminUser.subjectId;

      if (!subjectId) {
        this.errorService.handleError(
          { error: { message: "User subject id is missing" } },
          "Error updating non-admin user"
        );
        return;
      }

      this.authService.updateKeycloakManagedUserBySubject(subjectId, payload).subscribe({
        next: (request) => {
          this.router.navigate(["settings/user"], {
            state: {
              details: this.prevState,
              prevPage: "Edit-Non-Admin-User",
              success: true,
            },
          });
        },
        error: (error) => {
          this.errorService.handleError(error, "Error updating non-admin user");
        },
      });
    } else {
      this.authService.updateTempUser(this.selectedTempUser.tempUserId ?? 0, payload).subscribe({
        next: (request) => {
          this.router.navigate(["settings/user"], {
            state: {
              details: this.prevState,
              prevPage: "Edit-Non-Admin-User",
              success: true,
            },
          });
        },
        error: (error) => {
          this.errorService.handleError(error, "Error updating non-admin user");
        },
      });
    }
  }

  retrievePlantsByCompanyId(selected: any, firstRender?: any) {
    this.selectedCompany = selected;

    if (this.selectedPlant.plantId > 0 || this.plants.length > 0) {
      if (firstRender) {
      } else {
        this.resetPlant = true;
        this.selectedPlant = {
          plantId: 0,
          plantName: "",
          isDeleted: false,
        };

        this.selectedNonAdminGroup = {
          groupId: 0,
          groupName: "",
          plantId: 0,
          isDeleted: false,
        };

        this.plants = [];
      }
    }

    this.plantService
      .retrieveCompanyPlants(this.selectedCompany.companyId.toString())
      .subscribe({
        next: (response) => {
          this.plants = response.filter((item) => !item.isDeleted);
        },
        error: (err) => {
          this.errorMessage = this.errorService.handleRetrievalErrors(err);
        },
      });
    this.resetPlant = false;
  }

  resetFields() {
    this.selectedPlant = {
      plantId: 0,
      plantName: "",
      isDeleted: false,
    };

    if (this.currentRole === Roles.superAdmin) {
      this.selectedCompany = {
        companyId: 0,
        companyName: "",
        isDeleted: false,
      };
    }
  }

  retrieveUnitsByPlantId(selected: any) {
    // get modification window details
    this.selectedPlant = selected;
    this.selectedNonAdminGroup = {
      groupId: 0,
      groupName: "",
      plantId: 0,
      isDeleted: false,
    };
    this.selectedTempGroup = {
      tempUserGroupId: 0,
      groupName: "",
      plantId: 0,
      isDeleted: false
    };

    this.retrieveGroupsBySelectedPlant();
  }

  selectedNonAdminGroup: Group = {
    groupId: 0,
    groupName: "",
    plantId: 0,
    isDeleted: false,
  };

  selectedTempGroup: TempGroup = {
    tempUserGroupId: 0,
    groupName: "",
    plantId: 0,
    isDeleted: false
  }

  handleSelectGroup(item: any) {
    if (this.editMode == 'non-admin') {
      this.selectedNonAdminGroup = item;
    } else {
      this.selectedTempGroup = item;
    }
  }

  activateSubmitBtn() {
    if (!this.hasSelectedGroup()) {
      return false;
    }

    return this.hasGroupChanged();
  }

  hasSelectedGroup() {
    return this.editMode == 'temp-user'
      ? this.selectedTempGroup.tempUserGroupId !== 0
      : this.selectedNonAdminGroup.groupId !== 0;
  }

  hasGroupChanged() {
    if (
      this.prevState.company?.companyId !== this.selectedCompany?.companyId ||
      this.prevState.plant?.plantId !== this.selectedPlant?.plantId
    ) {
      return true;
    }

    if (this.editMode == 'temp-user') {
      return this.prevState.tempGroup?.tempUserGroupId !== this.selectedTempGroup.tempUserGroupId;
    }

    return this.prevState.group?.groupId !== this.selectedNonAdminGroup.groupId;
  }

  retrieveGroupsBySelectedPlant() {
    const retrieveGroups: any = this.editMode == 'temp-user'
      ? this.groupService.retrieveTempGroupPlant(this.selectedPlant.plantId)
      : this.groupService.retrieveGroupPlant(this.selectedPlant.plantId);

    retrieveGroups.subscribe({
      next: (response: any) => {
        this.groups = response;
      },
      error: (err: any) => {
        this.errorMessage = this.errorService.handleRetrievalErrors(err);
      },
    });
  }

  prevState: any = {};
  pageDetails: string = "Add-Non-Admin-User";
  ngOnInit() {
    this.currentRole = localStorage.getItem("role");
    this.selectedCompany = history.state?.selectedValues?.company;
    this.selectedPlant = history.state?.selectedValues?.plant;
    this.editMode = history?.state?.mode;

    if (this.editMode == 'temp-user') {
      this.selectedTempUser = history?.state?.data;
      this.selectedTempGroup = history?.state?.data?.tempUserGroup || {
        tempUserGroupId: history?.state?.data?.tempUserGroupId || 0,
        groupName: "",
        plantId: this.selectedPlant?.plantId || 0,
        isDeleted: false,
      };
      this.currentGroup = history?.state?.data?.tempUserGroup;
      this.firstName = this.selectedTempUser?.firstName || "";
      this.lastName = this.selectedTempUser?.lastName || "";
      this.email = this.selectedTempUser?.email || "";
    } else if (this.editMode == 'non-admin') {
      this.selectedNonAdminUser = history?.state?.data;
      this.selectedNonAdminGroup = history?.state?.data?.group?.[0] || {
        groupId: 0,
        groupName: "",
        plantId: this.selectedPlant?.plantId || 0,
        isDeleted: false,
      };
      this.currentGroup = history?.state?.data?.group?.[0];
      this.firstName = this.selectedNonAdminUser?.firstName || "";
      this.lastName = this.selectedNonAdminUser?.lastName || "";
      this.email = this.selectedNonAdminUser?.email || "";
    }

    if (this.currentRole === Roles.admin) {
      this.subtext = "Select Plant and Group below to edit.";
    }

    this.prevState = {
      company: this.selectedCompany,
      plant: this.selectedPlant,
      group: this.selectedNonAdminGroup,
      tempGroup: structuredClone(this.selectedTempGroup),
      userType: (this.editMode == 'non-admin' ? this.userTypes[0] : this.userTypes[1])
    };

    this.companyService.retrieveCompanies().subscribe({
      next: (companies) => {
        this.companies = companies.filter((item) => !item.isDeleted);
        if (this.currentRole === Roles.admin) {
          this.plantService.retrieveAllPlants().subscribe({
            next: (response) => {
              this.plants = response;
            },
            error: (err) => {
              this.errorMessage = this.errorService.handleRetrievalErrors(err);
            },
          });
        } else {
          this.retrievePlantsByCompanyId(this.selectedCompany, true);
        }
      },
      error: (response) => {
        this.errorMessage = this.errorService.handleRetrievalErrors(response);
      },
    });

    this.retrieveGroupsBySelectedPlant();

  }
}
